import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BUILD_INFO } from 'src/environments/build-info';

import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Capacitor } from '@capacitor/core';
import * as Sentry from '@sentry/angular';

function generateUUID(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export const trackingInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  if (!request.url.includes(environment.apiBaseUrl)) {
    return next(request);
  }

  const requestId = generateUUID();
  const platform = Capacitor.getPlatform();

  request = request.clone({
    headers: request.headers
      .set('X-Request-ID', requestId)
      .set('X-App-Version', environment.version)
      .set('X-App-Commit', BUILD_INFO.commitHash)
      .set('X-App-Platform', platform),
  });

  Sentry.addBreadcrumb({
    category: 'http',
    message: `${request.method} ${request.urlWithParams}`,
    data: { requestId, platform },
    level: 'info',
  });

  return next(request);
};
